var map = {
	"./companion-start.png": 90308,
	"./hero-start.png": 10810,
	"./tumulte-1-1.png": 55265,
	"./tumulte-1-2.png": 6282,
	"./tumulte-2-1.png": 96818,
	"./tumulte-2-2.png": 61961,
	"./tumulte-3-1.png": 89399,
	"./tumulte-3-2.png": 668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77789;